import { type IIntegration, type IIntegrationSupport, type TIntegrationCategory } from '~~/models/Unified';
// Slim copies written by server/utils/minify-data.ts; the full integrations.json is server-side only (TICKET-2238)
import _INTEGRATIONS from '~/data/integrations.min.json';
import INTEGRATION_STATS from '~/data/integrations.stats.json';
import { MAP_CATS } from './categories';
import { HIDDEN_INTEGRATION_TYPES } from './redirects';

export type IIntegration2 = IIntegration & { created_at: string; recent: boolean };

export const FUTURE_INTEGRATIONS = (
    [
        { categories: ['hris'], name: '7Shifts', type: '7shifts' },
        { categories: ['hris'], name: 'Accelo', type: 'accelo' },
        { categories: ['hris'], name: 'AFAS', type: 'afas' },
        { categories: ['ats'], name: 'ApplicantStack', type: 'applicantstack' },
        // { categories: ['ats'], name: 'Ashby', type: 'ashby' },
        { categories: ['ats'], name: 'ATSanywhere.io', type: 'atsanywhere' },
        { categories: ['crm'], name: 'Capsule', type: 'capsule' },
        { categories: ['ats'], name: 'CATS', type: 'cats' },
        { categories: ['ats'], name: 'Clockwork', type: 'clockwork' },
        { categories: ['ats'], name: 'Comeet', type: 'comeet' },
        // { categories: ['ats'], name: 'Cornerstone TalentLink', type: 'cornerstonetalentlink' },
        { categories: ['martech'], name: 'ConstantContact', type: 'constantcontact' },
        { categories: ['martech'], name: 'DialPad', type: 'dialpad' },
        { categories: ['ats'], name: 'Dixa', type: 'dixa' },
        { categories: ['martech'], name: 'Drip', type: 'drip' },
        { categories: ['ats'], name: 'Eploy', type: 'eploy' },
        { categories: ['ats'], name: 'Engage', type: 'engage' },
        { categories: ['martech'], name: 'GetResponse', type: 'getresponse' },
        { categories: ['ticketing'], name: 'GitLab', type: 'gitlab' },
        { categories: ['martech'], name: 'Gladly', type: 'gladly' },
        // { categories: ['ticketing'], name: 'Gorgias', type: 'gorgias' },
        { categories: ['martech'], name: 'Height', type: 'height' },
        { categories: ['ticketing'], name: 'HelpScout', type: 'helpscout' },
        { categories: ['ats'], name: 'Harbour', type: 'harbour' },
        { categories: ['hris', 'ats'], name: 'HR Cloud', type: 'hrcloud' },
        { categories: ['hris'], name: 'HR Partner', type: 'hrpartner' },
        { categories: ['hris'], name: 'Humaans', type: 'humaans' },
        { categories: ['ats'], name: 'Jobsoid', type: 'jobsoid' },
        // { categories: ['ats'], name: 'Jobvite', type: 'jobvite' },
        { categories: ['ticketing'], name: 'Jira', type: 'jira' },
        { categories: ['ats'], name: 'JustCall', type: 'justcall' },
        { categories: ['ticketing'], name: 'Kustomer', type: 'kustomer' },
        { categories: ['hris'], name: 'Keka', type: 'keka' },
        { categories: ['ticketing'], name: 'Linear', type: 'linear' },
        { categories: ['hris'], name: 'Lano', type: 'lano' },
        { categories: ['hris'], name: 'Loket', type: 'loket' },
        { categories: ['hris'], name: 'Lucca', type: 'lucca' },
        // { categories: ['ats'], name: 'Manatal', type: 'manatal' },
        { categories: ['crm'], name: 'Microsoft Dynamics', type: 'microsoftdynamics' },
        { categories: ['crm'], name: 'MoxiWorks', type: 'moxiworks' },
        { categories: ['crm'], name: 'Nimble', type: 'nimble' },
        { categories: ['crm'], name: 'Nutshell', type: 'nutshell' },
        { categories: ['martech'], name: 'OmniSend', type: 'omnisend' },
        { categories: ['crm'], name: 'OutReach', type: 'outreach' },
        { categories: ['ticketing'], name: 'Pivotal Tracker', type: 'pivotaltracker' },
        { categories: ['crm'], name: 'Pipeliner', type: 'pipeliner' },
        { categories: ['ats'], name: 'Polymer', type: 'polymer' },
        { categories: ['ats'], name: 'Recruitee', type: 'recruitee' },
        // { categories: ['ats'], name: 'Recruiterflow', type: 'recruiterflow' },
        { categories: ['ats'], name: 'Recruitive', type: 'recruitive' },
        { categories: ['crm'], name: 'SharpSpring', type: 'sharpspring' },
        { categories: ['ticketing'], name: 'Shortcut', type: 'shortcut' },
        { categories: ['martech'], name: 'SendInBlue', type: 'sendinblue' },
        { categories: ['crm'], name: 'SugarCRM', type: 'sugarcrm' },
        { categories: ['crm'], name: 'TalkDesk', type: 'talkdesk' },
        { categories: ['ticketing'], name: 'Teamwork', type: 'teamwork' },
        { categories: ['crm'], name: 'Teamleader', type: 'teamleader' },
        // { categories: ['ats'], name: 'TeamTailer', type: 'teamtailer' },
        { categories: ['ticketing'], name: 'Targetprocess', type: 'targetprocess' },
        { categories: ['crm'], name: 'Trello', type: 'trello' },
        { categories: ['crm'], name: 'TriNet', type: 'trinet' },
        { categories: ['ticketing'], name: 'Wrike', type: 'wrike' },
        { categories: ['hris'], name: 'Zenefits', type: 'zenefits' },
        { categories: ['hris'], name: 'ZohoPeople', type: 'zohopeople' },
        { categories: ['ticketing'], name: 'ZohoDesk', type: 'zohodesk' },
        { categories: ['ticketing'], name: 'Workfront', type: 'workfront' },
        { categories: ['ats', 'hris'], name: 'UKG', type: 'ukg' },
        { categories: ['crm'], name: 'Procore', type: 'procore' },
        { categories: ['crm'], name: 'Follow Up Boss', type: 'followupboss' },
        { categories: ['crm'], name: 'Boom Town', type: 'boomtown' },
        { categories: ['crm'], name: 'Wise Agent', type: 'wiseagent' },
        { categories: ['ats'], name: 'Seven20', type: 'seven20' },
        { categories: ['ats'], name: 'Vincere', type: 'vincere' },
        { categories: ['crm'], name: 'LeadDesk', type: 'leaddesk' },
        { categories: ['crm'], name: 'Lime CRM', type: 'limecrm' },
        { categories: ['crm'], name: 'Up Sales', type: 'upsales' },
        { categories: ['crm'], name: 'SuperOffice', type: 'superoffice' },
        { categories: ['ticketing'], name: 'Puzzel', type: 'puzzel' },
        { categories: ['crm'], name: 'Loxysoft', type: 'loxysoft' },
        { categories: ['crm'], name: 'Headshed', type: 'headshed' },
        { categories: ['crm'], name: 'Get Accept', type: 'getaccept' },
    ] as IIntegration2[]
).map((i) => {
    i.in_progress = true;
    return i;
});

const recentDate = new Date();
recentDate.setDate(recentDate.getDate() - 45);
const recentDateString = recentDate.toISOString();

export const INTEGRATIONS: IIntegration2[] = _INTEGRATIONS
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter((a) => !HIDDEN_INTEGRATION_TYPES.includes(a.type)) as IIntegration2[];

for (const integration of INTEGRATIONS) {
    integration.recent = Boolean(integration.created_at && integration.created_at > recentDateString);
}

export const INTEGRATIONS_COUNT_10s = Math.floor((INTEGRATIONS.length + 1) /* hidden integrations filtered out in INTEGRATIONS */ / 10) * 10;

export const OBJECTS_COUNT = INTEGRATION_STATS.objects_count;
export const OBJECTS_COUNT_100s = Math.floor(OBJECTS_COUNT / 100) * 100;

export type TIntegrationSupportMap = { [type in string]?: { [objectType in string]?: IIntegrationSupport } };

/**
 * Per-integration `support` (methods and list/search flags), keyed by integration type.
 * Loaded on demand so the data only ships with the pages that render it.
 */
export async function loadIntegrationSupport(): Promise<TIntegrationSupportMap> {
    return (await import('~/data/integrations.support.min.json')).default as unknown as TIntegrationSupportMap;
}

// This is meant to be eventual replacemenet for MAP_CATS
export const INTEGRATION_CATEGORIES = {
    hris: { name: 'HR & Directory', data_type: 'employee' },
    ats: { name: 'ATS', data_type: 'hiring' },
    crm: { name: 'CRM', data_type: 'customer' },
    martech: { name: 'Marketing', data_type: 'lead' },
    ticketing: { name: 'Ticketing', data_type: 'issue' },
    enrich: { name: 'Enrichment', data_type: 'enrichment' },
    uc: { name: 'Call Center', data_type: 'support' },
    auth: { name: 'Authentication', data_type: '' },
    accounting: { name: 'Accounting', data_type: 'financial' },
    storage: { name: 'File Storage', data_type: 'document' },
    commerce: { name: 'E-Commerce', data_type: 'commerce' },
    payment: { name: 'Payment', data_type: 'transaction' },
    messaging: { name: 'Messaging', data_type: 'communication' },
    kms: { name: 'KMS & Help Center', data_type: 'knowledge' },
    task: { name: 'Task Management', data_type: 'productivity' },
    scim: { name: 'SCIM', data_type: 'employee' },
    lms: { name: 'LMS', data_type: 'course' },
    repo: { name: 'Repository', data_type: 'code repo' },
    genai: { name: 'Generative AI', data_type: 'prompt' },
    calendar: { name: 'Calendar', data_type: 'event' },
    verification: { name: 'Verification', data_type: 'verification' },
    ads: { name: 'Advertising', data_type: 'ads' },
    forms: { name: 'Forms', data_type: 'form submission' },
    shipping: { name: 'Shipping', data_type: 'shipping' },
    assessment: { name: 'Assessment', data_type: 'assessment' },
    signing: { name: 'E-Signature', data_type: 'signature' },
    clubs: { name: 'Clubs', data_type: 'club' },
    datastore: { name: 'Datastore', data_type: 'datastore' },
    analytics: { name: 'Analytics', data_type: 'analytics' },
    cdp: { name: 'Customer Data Platform', data_type: 'customer profile' },
    performance: { name: 'Performance Management', data_type: 'performance' },
    saml: { name: 'SAML Single Sign-On', data_type: 'saml' },
    social: { name: 'Social Media', data_type: 'social' },
    legal: { name: 'Legal', data_type: 'legal' },
    compute: { name: 'Compute & Hosting', data_type: 'compute' },
    healthcare: { name: 'Healthcare', data_type: 'healthcare' },
    property: { name: 'Property Management', data_type: 'property' },
    plm: { name: 'Product Lifecycle Management', data_type: 'product lifecycle' },
} satisfies {
    [path in Exclude<TIntegrationCategory, 'passthrough' | 'metadata'>]: {
        name: string;
        data_type: string;
    };
};

export const CATS = Object.keys(MAP_CATS) as (keyof typeof MAP_CATS)[]; //as string[];
// _INTEGRATIONS.forEach((i) => {
//     i.categories.forEach((c) => CATS.push(c));
// });
// CATS = [...new Set(CATS)];
// console.log('cats', CATS);

export const NEW_CATEGORIES: TIntegrationCategory[] = ['compute', 'healthcare', 'property', 'plm'];
